// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import 'babel-polyfill'
// import promise from 'es6-promise';
// promise.polyfill();
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
//测试地址
// Vue.prototype.baseUrl = 'http://121.40.28.76:8761';
//真实地址
// Vue.prototype.baseUrl = 'http://180.167.139.67:8761';
//医院测试
// Vue.prototype.baseUrl = 'http://125.215.54.37:8761';

Vue.prototype.baseUrl = 'http://101.132.178.101:8761';




Vue.config.productionTip = false
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js